import { render, staticRenderFns } from "./NetworkTab.vue?vue&type=template&id=23adc6ee&"
import script from "./NetworkTab.vue?vue&type=script&lang=js&"
export * from "./NetworkTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports